var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecurrence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 2.00018C5.35317 2.00018 2.6665 4.68685 2.6665 8.00018H0.666504L3.25984 10.5935L3.3065 10.6869L5.99984 8.00018H3.99984C3.99984 5.42018 6.0865 3.33352 8.6665 3.33352C11.2465 3.33352 13.3332 5.42018 13.3332 8.00018C13.3332 10.5802 11.2465 12.6669 8.6665 12.6669C7.37984 12.6669 6.21317 12.1402 5.37317 11.2935L4.4265 12.2402C5.51317 13.3269 7.0065 14.0002 8.6665 14.0002C11.9798 14.0002 14.6665 11.3135 14.6665 8.00018C14.6665 4.68685 11.9798 2.00018 8.6665 2.00018ZM7.99984 5.33352V8.66685L10.8532 10.3602L11.3332 9.55352L8.99984 8.16685V5.33352H7.99984Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurrence);
export default ForwardRef;